import { hasDiagramDarkMode } from '@y42/gojs';
import { variableColors } from '@y42/model';
import { Binding, Geometry, GraphObject, Panel, Part, Shape, Spot } from 'gojs';
import { OrchestrationNodeBindings, OrchestrationUINode } from '../../../../models/orchestration-diagram.model';

const $ = GraphObject.make;

// these are path strings from libs/assets/images/general/job-icon.svg
const upperPartString =
  'M11.9638 2.70711C12.5938 2.07714 12.1476 1 11.2567 1H2.4209C1.86861 1 1.4209 1.44772 1.4209 2V10.8358C1.4209 11.7267 2.49804 12.1729 3.12801 11.5429L11.9638 2.70711Z';
const lowerPartString =
  'M5.58501 15C4.69411 15 4.24794 13.9229 4.87791 13.2929L13.7137 4.45711C14.3437 3.82715 15.4208 4.27332 15.4208 5.16422V14C15.4208 14.5523 14.9731 15 14.4208 15H5.58501Z';

export const gojsJobIcon = (props: Record<string, unknown> = {}, bindings: go.Binding[] = []) =>
  $(Panel, Panel.Spot, { ...props }, upperHalf(), lowerHalf(), ...bindings);

const upperHalf = () =>
  $(
    Shape,
    {
      width: 12,
      height: 12,
      strokeWidth: 0,
      geometry: Geometry.parse(upperPartString, true),
      alignment: new Spot(0.35, 0.35),
    },
    upperHalfFillBinding(),
  );

const lowerHalf = () =>
  $(
    Shape,
    {
      width: 15,
      height: 15,
      strokeWidth: 0,
      geometry: Geometry.parse(lowerPartString, true),
      alignment: new Spot(0.65, 0.65),
    },
    lowerHalfFillBinding(),
  );

const upperHalfFillBinding = () =>
  new Binding('fill', '', (node: OrchestrationUINode, part: Part) => {
    const hasDarkMode = hasDiagramDarkMode(part.diagram);
    const hasIncrementalImport = node[OrchestrationNodeBindings.NodeConfig]?.incremental;
    if (hasIncrementalImport) {
      return hasDarkMode ? variableColors.gray800 : variableColors.gray400;
    }
    return hasDarkMode ? variableColors.gray400 : variableColors.gray700;
  });

const lowerHalfFillBinding = () =>
  new Binding('fill', '', (node: OrchestrationUINode, part: Part) => {
    const hasDarkMode = hasDiagramDarkMode(part.diagram);
    return hasDarkMode ? variableColors.gray400 : variableColors.gray700;
  });
